import { gettext } from '@eventbrite/i18n';
import {
    trackAnalyticsEvent,
    trackEventFromState,
    trackEventFromStateOnPageUnload,
} from '@eventbrite/site-analytics';
import { $FixMe } from '@eventbrite/ts-utils';
import React from 'react';
import { connect } from 'react-redux';
import { SearchEventCardStyleSwitcher } from '../../../../components/EventCard';
import {
    GA_SEARCH_CATEGORY,
    SEARCH_TOP_MATCH_NAVIGATION,
} from '../../../../constants/analytics';
import { trackEventClickInternal as trackEventClickInternalAction } from '../../../../redux/actions/analytics';
import { Event } from '../../../../types/index';
import {
    eventsCardInfoLookup,
    getSearchSection,
} from '../../../../utils/general';
import { addSearchIdToGaAction } from '../../utils/analytics';
import './TopMatchContainer.scss';

const getTopMatch = ({
    context,
    entities,
    currencyFormat,
    section,
}: {
    context: any;
    entities: any;
    currencyFormat: string;
    section: string;
}) => {
    const topMatchIds = context.find(
        (contextItem: { topMatchIds: string[] }) => contextItem.topMatchIds,
    )?.topMatchIds;

    const events = topMatchIds.map((id: string) => entities[id]);

    const formattedEvents = eventsCardInfoLookup({
        bucketsContent: events,
        currencyFormat,
        section,
    });

    return formattedEvents;
};

interface TopMatchProps {
    isAuthenticated?: boolean;
    onTrackEventClickInternal: Function;
    query: string;
    results: any;
    trackGAEvent: Function;
}

const TopMatch = (props: TopMatchProps) => {
    const query = props.query;

    React.useEffect(() => {
        trackAnalyticsEvent({
            category: GA_SEARCH_CATEGORY,
            action: 'TopMatchShown',
            label: query,
            nonInteraction: true,
        });
    }, [query]);

    const handleTrackClick = (
        _index?: number,
        eventId?: string,
        _unusedAction?: Function,
        organizerFollowerCount?: number,
    ) => {
        const { trackGAEvent } = props;
        const action = 'ViewEventTopMatch';

        trackGAEvent({
            action,
            category: GA_SEARCH_CATEGORY,
            label: eventId,
            metrics: {
                organizerFollowerCount: organizerFollowerCount || 0,
            },
        });
    };

    const handleTrackClickInternal = (_index: number, id: string) => {
        const { onTrackEventClickInternal } = props;

        const trackingData = {
            navigation: SEARCH_TOP_MATCH_NAVIGATION,
            itemId: id,
        };

        onTrackEventClickInternal(trackingData);
    };

    return (
        <section className="top-match">
            <h2 className="top-match__header eds-text-hm">
                {gettext('Most popular matches')}
            </h2>
            <ul className="top-match__events">
                {props.results.map((event: Event, index: number) => {
                    return (
                        <li key={`top-match-${event.id}`}>
                            <SearchEventCardStyleSwitcher
                                type="list"
                                isAuthenticated={props.isAuthenticated}
                                trackClick={handleTrackClick.bind(
                                    null,
                                    index,
                                    event.id,
                                )}
                                trackClickInternal={handleTrackClickInternal.bind(
                                    null,
                                    index,
                                )}
                                trackGAEvent={props.trackGAEvent}
                                heapLocationString="Search - Top Match"
                                {...event}
                            />
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

export const _mapStateToProps = (state: any) => {
    const section = getSearchSection(state.location.isOnline);
    const results = getTopMatch({
        context: state.content.entityContext,
        entities: state.content.entities,
        currencyFormat: state.currencyFormat,
        section,
    });

    return {
        results,
        query: state.search.eventSearch.q,
        isAuthenticated: state.auth.isAuthenticated,
        trackGAEvent: (action: any) =>
            trackEventFromState(state, addSearchIdToGaAction(action, state)),
        trackGAEventOnPageUnload: (action: any) =>
            trackEventFromStateOnPageUnload(
                state,
                addSearchIdToGaAction(
                    {
                        ...action,
                        category: GA_SEARCH_CATEGORY,
                    },
                    state,
                ),
            ),
    };
};

const _mapDispatchToProps = (dispatch: Function) => ({
    onTrackEventClickInternal: (...args: [$FixMe]) =>
        dispatch(trackEventClickInternalAction(...args)),
});

export const TopMatchContainer = connect(
    _mapStateToProps,
    _mapDispatchToProps,
)(TopMatch);
